module.exports = __webpack_public_path__ + "static/media/about-mission-2025.dcc25933.png";